export default function HeroSection() {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/1ba314f04f6f6e080d0d7b39b40ea0f7.jpg"
          alt="Hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-black/50 to-black/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10 flex flex-col lg:flex-row items-center lg:items-end justify-between gap-12 py-32">
        {/* Left */}
        <div className="flex-1 max-w-2xl">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 mb-8">
            <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
            <span className="text-white/90 text-sm font-medium tracking-wide">iOS Platform Specialists</span>
          </div>
          <h1 className="text-5xl md:text-7xl font-extralight text-white leading-tight mb-4">
            Modern Apps
            <br />
            <span className="font-extrabold">for iOS</span>
          </h1>
          <p className="text-white/70 text-lg md:text-xl leading-relaxed max-w-lg mt-6">
            Building secure, high-performance mobile applications that enhance user experience and protect digital lives.
          </p>

          {/* Stats */}
          <div className="flex gap-10 mt-12">
            {[
              { value: "99.9%", label: "Uptime" },
            ].map((stat) => (
              <div key={stat.label}>
                <div className="text-3xl font-bold text-white">{stat.value}</div>
                <div className="text-white/50 text-sm mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Right card */}
        <div className="flex-shrink-0 w-full lg:w-80">
          <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-6">
            <p className="text-white/60 text-xs uppercase tracking-widest mb-3">About Us</p>
            <p className="text-white text-base leading-relaxed">
              CERTROM SRL is a team of experts developing modern applications for the iOS platform. Our products — VPN and Cleaner — are designed to enhance user experience and improve the security of mobile devices.
            </p>
            <div className="mt-6 flex gap-3">
              <div className="flex-1 bg-white/10 rounded-xl p-3 text-center">
                <i className="ri-shield-keyhole-line text-emerald-400 text-xl" />
                <div className="text-white text-xs mt-1.5 font-medium">VPN</div>
              </div>
              <div className="flex-1 bg-white/10 rounded-xl p-3 text-center">
                <i className="ri-sparkling-2-line text-sky-400 text-xl" />
                <div className="text-white text-xs mt-1.5 font-medium">Cleaner</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/40 animate-bounce">
        <i className="ri-arrow-down-line text-lg" />
        <span className="text-xs tracking-widest uppercase">Scroll</span>
      </div>
    </section>
  );
}
